import React, { useState } from 'react';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import CaseTypeOrganizationUnitModal from './CaseTypeOrganizationUnitModal';
import { useAppContext } from '../../../../../Services/AppContext';
import NetteApiClient from '../../../../../Services/NetteApiClient';

interface Props {
	workplaceId: string;
	organizationUnitId: string;
	isOnlyOneRoot: boolean;
}

const CaseTypeOrganizationUnitButton: React.FC<Props> = ({
	organizationUnitId,
	workplaceId,
	isOnlyOneRoot,
}) => {
	const [isOrganizationUnitDetailOpen, setIsOrganizationUnitDetailOpen] =
		useState(false);
	const { redirectManagerCaseTypes } = useAppContext();

	const handleEditOrganizationUnit = () => {
		setIsOrganizationUnitDetailOpen(true);
	};

	const handleOnSuccess = () => {
		setIsOrganizationUnitDetailOpen(false);
		NetteApiClient.get(redirectManagerCaseTypes);
	};

	return (
		<>
			<Button
				theme={Theme.BLUE}
				title='base.shared.edit'
				onClick={handleEditOrganizationUnit}
			/>
			{isOrganizationUnitDetailOpen && (
				<CaseTypeOrganizationUnitModal
					isOpened={isOrganizationUnitDetailOpen}
					onClose={() => setIsOrganizationUnitDetailOpen(false)}
					onSuccess={handleOnSuccess}
					organizationUnitId={organizationUnitId}
					workplaceId={workplaceId}
					isOnlyOneRoot={isOnlyOneRoot}
				/>
			)}
		</>
	);
};

export default CaseTypeOrganizationUnitButton;
